/**
 * MSAL Browser Configuration for Azure AD Authentication
 *
 * This file configures the Microsoft Authentication Library (MSAL) for web-only authentication.
 */

import { Configuration, BrowserCacheLocation } from '@azure/msal-browser';
import { ROUTER_PATHS } from '@/app/routes';

export const msalConfig: Configuration = {
	auth: {
		clientId: import.meta.env.AUTH_CLIENT_ID,
		authority: `https://login.microsoftonline.com/${import.meta.env.AZURE_TENANT_ID}`,
		redirectUri: `${window.location.origin}/blank.html`,
		postLogoutRedirectUri: `${window.location.origin}${ROUTER_PATHS.login.getLink()}`,
	},
	cache: {
		cacheLocation: BrowserCacheLocation.LocalStorage,
		storeAuthStateInCookie: true, // For iOS 14+ support
	},
};

export const loginRequest = {
	scopes: [import.meta.env.API_ACCESS_SCOPE],
};
